/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimeSlotDto } from './TimeSlotDto';
import {
    TimeSlotDtoFromJSON,
    TimeSlotDtoFromJSONTyped,
    TimeSlotDtoToJSON,
} from './TimeSlotDto';

/**
 * 
 * @export
 * @interface ScheduleCeremonyVLEIRequestDto
 */
export interface ScheduleCeremonyVLEIRequestDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof ScheduleCeremonyVLEIRequestDto
     */
    workflowInstanceId: string;
    /**
     * 
     * @type {TimeSlotDto}
     * @memberof ScheduleCeremonyVLEIRequestDto
     */
    timeSlot: TimeSlotDto;
}

/**
 * Check if a given object implements the ScheduleCeremonyVLEIRequestDto interface.
 */
export function instanceOfScheduleCeremonyVLEIRequestDto(value: object): boolean {
    if (!('workflowInstanceId' in value)) return false;
    if (!('timeSlot' in value)) return false;
    return true;
}

export function ScheduleCeremonyVLEIRequestDtoFromJSON(json: any): ScheduleCeremonyVLEIRequestDto {
    return ScheduleCeremonyVLEIRequestDtoFromJSONTyped(json, false);
}

export function ScheduleCeremonyVLEIRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleCeremonyVLEIRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'],
        'timeSlot': TimeSlotDtoFromJSON(json['timeSlot']),
    };
}

export function ScheduleCeremonyVLEIRequestDtoToJSON(value?: ScheduleCeremonyVLEIRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'timeSlot': TimeSlotDtoToJSON(value['timeSlot']),
    };
}

